import ApplicationController from './application_controller';

// The deals list's inline editor row (administration/deals/_quick_edit_row). Turbo Streams insert
// and replace the row; this brings it into view when it lands and closes it on Cancel.
export default class extends ApplicationController {
  connect() {
    this.element.scrollIntoView({ block: 'nearest' });
    this.element.querySelector('input:not([type="hidden"]):not([disabled]), textarea')?.focus();
  }

  close() {
    const editLink = this.element.previousElementSibling?.querySelector('a[data-turbo-stream]');
    this.element.remove();
    editLink?.focus();
  }
}
